import type { FaireProductEntity } from "../../entity_types/product";

export const p_hchkkh2qyn: FaireProductEntity = {
  token: "p_hchkkh2qyn",
  type: "product",
  name: "Tiny Small Gold Cross Charm Necklace in 925 Sterling Silver",
  brandToken: "b_xd955m9fpf",
  brandName: "Perimade & Co. LLC",
  imageUrl:
    "https://cdn.faire.com/fastly/ed6e413a22b23db72ca7ef604c4a6161d190603c3203aa13eaaebc241a186d46.png",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/94fdca332fb4ea07de27790319dab47393950ffb7cb003497b989dcaba5970fd.jpeg",
    "https://cdn.faire.com/fastly/ac06edabe3794c38c17df2ab8c2c08aeb8fe2e831a8439ff85e1b505cd0eb6e8.png",
    "https://cdn.faire.com/fastly/4d9927d4e9b3d381e0073c3d1a7ea96a111ec46cf41cade8fd85cdf35ce13108.png",
  ],
  priceDollars: 21.44,
  description:
    "Description & Details\n\nEmbrace the timeless symbol of faith, spirituality, and devotion with our exquisite pieces inspired by the sacred cross. Each design in our collection is meticulously crafted to honor the significance of the cross and serve as a beautiful reminder of one's beliefs and values.\n\n• Material: Solid 925 Sterling Silver ∙ Cubic Zirconia\n• Finish: Hypoallergenic ∙ Gold Plating\n• Dimensions: 40 - 45 cm chain, adjustable\n• All our work is custom made by hand with love",
  tags: [],
  msrpDollars: 42.87,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-26T23:57:22.191Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
